export default () => {
  // Toggle cta form
  window.addEventListener("DOMContentLoaded", () => {
    const toggleBtn = document.querySelector('#openCtaForm');
    toggleBtn.addEventListener("click", (e) => { 
      if(document.querySelector('.ctaForm').style.display === 'block') {
        document.querySelector('.ctaForm').style.display = 'none';
        
      } else {
        document.querySelector('.ctaForm').style.display = 'block';
        document.querySelector('#openCtaForm').style.display = 'none';
        document.querySelector('#ctaText').style.display = 'none';

      }
      
    });
  });

}